import React from 'react';
import PropTypes from 'prop-types';

const withCustomInputHoc = (WrappedComponent) => {
  class HOC extends React.Component {
    constructor (props) {
      super(props);
      this.state = {
        hasError: false
      };
      this.errorFn = this.errorFn.bind(this);
      this.validFn = this.validFn.bind(this);
      this.isValid = this.isValid.bind(this);
      this.inputRef = this.inputRef.bind(this);
    }

    getValue () {
      const { value } = this.target.dataset || {};
      return value;
    }

    isValid () {
      let errorFree = true;
      const { optional } = this.props;
      const { value } = this.target.dataset || {};

      if (!optional && !value) {
        this.errorFn();
        errorFree = false;
      } else {
        this.validFn();
      }

      return errorFree;
    }

    validFn () {
      this.setState({ hasError: false });
    }

    errorFn () {
      this.setState({ hasError: true });
    }

    inputRef (ref) {
      this.target = ref;
      return this.target;
    }

    clearValue () {
      this.setState({ hasError: false });
    }

    render () {
      const { hasError } = this.state;
      return (
        <WrappedComponent
          inputRef={this.inputRef}
          hasError={hasError}
          validFn={this.validFn}
          {...this.props}
        />
      );
    }
  }
  HOC.propTypes = {
    optional: PropTypes.bool
  };
  return HOC;
};

export default withCustomInputHoc;
